/**
 * Ejar's vouchers read ONE way on the web (owner, 1 Oct 2026) - the twin of the engine's rule in
 * engine/api/contract_money.py (voucher_active / voucher_sign / is_deposit_voucher). Both read the same case table,
 * engine/tests/fixtures/voucher_rule_cases.json, so they cannot drift apart.
 *
 * Ejar's voucherType says the direction: a Receipt is money in; a Disbursement or a Refund is money going back to the
 * customer (a Disbursement at Close or Cancel Contract too - the "Fill from Ejar" rule used to count it as PAID because
 * its operation name has no "refund" in it). A voucher marked inactive or deleted counts for nothing, and the insurance
 * deposit is never rent paid.
 */
const MONEY_OUT = ['disbursement', 'refund'];

/** A voucher that counts: not marked inactive (isActive false) and not deleted. */
export const voucherActive = (v) => !!v && v.isActive !== false && !v.isDeleted;

/** +1 money in (Receipt), -1 money out (Disbursement / Refund), 0 any other type or an inactive voucher. */
export const voucherSign = (v) => {
    if (!voucherActive(v)) return 0;
    const kind = String(v.voucherType || '').trim().toLowerCase();
    if (kind === 'receipt') return 1;
    return MONEY_OUT.includes(kind) ? -1 : 0;
};

/** The insurance deposit ("Insurance Deposit" / "Insurance Deposit Refund"): kept apart, never a payment. */
export const isDepositVoucher = (v) => String((v && v.voucherOperationType) || '').toLowerCase().includes('deposit');
